// 品牌标识
export enum Brand {
  Xwx = '100',
  Xwsy = '120',
  Xwyk = '9999'
}
